var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrmContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8,10a5,5,0,1,1,5-5A5,5,0,0,1,8,10ZM8,1a4,4,0,1,0,4,4A4,4,0,0,0,8,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15,16H14a5.87,5.87,0,0,0-6-6,5.94,5.94,0,0,0-6,6H1A6.93,6.93,0,0,1,8,9,6.88,6.88,0,0,1,15,16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmContact);
export default __webpack_public_path__ + "static/media/crm-contact.41e4d2f8.svg";
export { ForwardRef as ReactComponent };